module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_6000.e87f7319.png";